export default class RetailPriceListService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  getRetailPriceList(retailPriceListId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/retailPriceList/get/${retailPriceListId}`);
  }

  editRetailPriceList(retailPriceList) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/retailPriceList/add', retailPriceList);
  }

  listRetailPriceList(filterParams) {
    let query = '';

    query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
    query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
    query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
    query += `&ascending=${filterParams.pageCriteria.ascending}`;

    query += `&brandIds=${filterParams.brand.brandId}`;

    if (filterParams.brandModel.brandModelId !== 0) {
      query += `&modelId=${filterParams.brandModel.brandModelId}`;
    }

    if (filterParams.variant) {
      query += `&variant=${filterParams.variant}`;
    }

    return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/retailPriceList/list' + query);
  }

  updateState(retailPriceListId, state) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/retailpricelist/update/${retailPriceListId}/${state}`);
  }

  getRetailPriceListsByBrandId(brandId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/retailPriceList/getretailrricelistbybrandId/${brandId}`);
  }

  clear() {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/retailPriceList/clear`);
  }  
}



// WEBPACK FOOTER //
// ./client/app/components/admin/retailPriceList/retailPriceList.Service.js